<template lang="html">
	<div id="app">
    <div  class="bg-white" v-if="!showiframe">
	<router-view :key="this.$store.state.sidebar.navigationClicked"></router-view>
    </div>
	<div class="fadeinoliver w-100" v-if="showloading && !showiframe">
		<img id="f1" src="@/assets/images/oliver-c.png" class="mx-auto">
	    <img id="f2" src="@/assets/images/oliver-d.png" class="mx-auto" >
	    <img id="f3" src="@/assets/images/oliver-e.png" class="mx-auto" >
	    <small class="text-primary">{{$t('lang.search.loading')}}...</small>
	</div>

  <!-- <iframe
  v-if="landing && showiframe"
   style="height:2000px;"
 id="inlineFrameExample"
 width="100%" height="2015px" :src="landing" frameborder="0"
 allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
loading="lazy" allowfullscreen>
</iframe> -->

	</div>
</template>

<script lang="js">

import { myCalendarService } from "@/_services";


	export default {
		name: 'appoliver',
        data() {
            return {
              showloading:true,
              showiframe:false,
              landing:false,
              faviconUrl: require('@/assets/images/icono-generico.png')
            };
        },
        created(){
          let host = window.location.host;

            if( window.location.href.includes("/mycalendar")  ||
                window.location.href.includes("/calendar") ||
                window.location.href.includes("/unsubscribe")) {
                this.showloading = false
                this.showiframe = false
            } else {
              myCalendarService.getLandingLink(host).then((result) => {
                if(result[0].landing_link !== undefined) {
                  this.landing = result[0].landing_link;
                  window.location.href = this.landing;

                  //Cambio titulo
                  const title = (result[0].name) ? result[0].name : "."
                  document.title = title

                  //Cambio Favicon
                  this.udpateFavicon()


                } else {
                 this.landing = 'https://oliverlist.com'

                  //Cambio titulo
                  document.title = "Oliverlist"

                 //Cambio Favicon
                  this.udpateFavicon()
                }
          })

              this.showiframe = true
            }
        },
        methods: {
          udpateFavicon(){
            let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = this.faviconUrl;
            document.getElementsByTagName('head')[0].appendChild(link);
          }
        }
	}

</script>
<style scoped>
.fadeinoliver small {
	z-index:-3;
    top:40%;
    margin-top:95px;
    width:100%;
    text-align:center;
    position:absolute;
}
.fadeinoliver img {
	width:90px;
    left: 50%;
	z-index:-999;
    top:40%;
    margin-left: -45px !important;
    position:absolute;
    -webkit-animation-name: fade;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 6s;
    animation-name: fade;
    animation-iteration-count: infinite;
    animation-duration: 6s;
}

@-webkit-keyframes fade {
    0% {opacity: 0;}
    20% {opacity: 1;}
    33% {opacity: 1;}
    53% {opacity: 0;}
    100% {opacity: 0;}
}
@keyframes fade {
    0% {opacity: 0;}
    20% {opacity: 1;}
    33% {opacity: 1;}
    53% {opacity: 0;}
    100% {opacity: 0;}
}

#f1 {
}
#f2 {
    -webkit-animation-delay: -2s;
}
#f3 {
    -webkit-animation-delay: -4s;
}

</style>
